export default function Footer() {
  return <footer id="footer">&copy; 2025 Gonda Armand</footer>;
}
